var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('LanguageTable',{ref:"table",attrs:{"title":"Users"},on:{"addRoster":_vm.showLanguageModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }